// ----------------------------------------------------------------------------
// Component: Video Block
// ----------------------------------------------------------------------------
//
// Content component that positions a video in a custom-sized block, or in
// the flex-position or flex-grid.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block';

// Styles
import './_video-block.scss';

// -------------------------------------
// Variables
// -------------------------------------
// Selectors
const VIDEO          = '.video-block__video';


// -------------------------------------
// Helpers
// -------------------------------------
// Get all video elements and their containers
const videoElements = document.querySelectorAll(VIDEO);

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Function to handle scrolling for each video
function handleScroll() {
    videoElements.forEach(video => {
        const videoContainer = video.parentElement;
        if (isElementInViewport(videoContainer)) {
            video.play();
        }
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    // Initial check on page load
    handleScroll();

    // Event listener for scroll
    window.addEventListener('scroll', handleScroll);
});
